import React from 'react';
import {Accordion, Button} from 'react-bootstrap';
import PropTypes from 'prop-types';

const SpoilerInfo = (props) => {
  return <Accordion>
    <Accordion.Toggle as={ Button } variant="link" eventKey="info"
                      className='text-secondary px-0 mb-1' title={ gettext('Развернуть информацию') }>
      { props.title ? props.title : gettext('Информация') }
    </Accordion.Toggle>
    <Accordion.Collapse eventKey="info">
      { props.children }
    </Accordion.Collapse>
  </Accordion>;
};

SpoilerInfo.propTypes = {
  title: PropTypes.string,
  children: PropTypes.string.isRequired,
};

export default SpoilerInfo;